<template>
  <div class="userbox">
    <div class="user-content">
      <span class="dialog" @click="dialogShow">编辑信息</span>
      <p class="user-title">基本信息<span></span></p>
      <el-form :model="form">
        <el-form-item
          label="用户名 :"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            :disabled="true"
            v-model="form.username"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="公司名称(全称) :"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            :disabled="true"
            v-model="form.company"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="公司地址 :"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            :disabled="true"
            v-model="form.company_addr"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名 :" :label-width="formLabelWidth" prop="name">
          <el-input
            :disabled="true"
            v-model="form.realname"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="career" label="职位" :label-width="formLabelWidth">
          <el-input :disabled="true" v-model="form.career"></el-input>
        </el-form-item>
        <el-form-item prop="industry" label="行业" :label-width="formLabelWidth">
          <el-input :disabled="true" v-model="form.industry"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号 :"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            :disabled="true"
            v-model="form.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱 :" :label-width="formLabelWidth" prop="name">
          <el-input
            :disabled="true"
            v-model="form.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <p class="user-title">安全信息<span></span></p>
        <el-form-item
          label="登录密码:"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            :disabled="true"
            v-model="form.email"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <p class="user-title">密钥信息<span></span></p>

        <el-form-item
          label="API KEY :"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-tooltip placement="top">
            <div slot="content">
              1、密钥由奇安信威胁情报中心颁发，可用于资源下载页面的开源工具下载。<br />
              2、您在资源下载页面请求后，可以根据颁发的密钥及接口地址，自动请求获取当前离线资源包
            </div>
            <img class="warning" src="@/assets/images/warning.png" alt="" />
          </el-tooltip>
          <el-input
            :disabled="true"
            v-model="form.token"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <UserinfoDialog
      :dialogFormVisible="dialogFormVisible"
      @closeMoule="closeMoule"
      @reloaduserinfo='reloaduserinfo'

    />
  </div>
</template>

<script>
import UserinfoDialog from '@/components/userinfo-dialog.vue';
import { User } from '@/api/api'

export default {
  name: '',
  data () {
    return {
      form: {
        realname: '',
        username: '',
        phone: '',
        email: '',
        company: '',
        company_addr: '',
        token: ''
      },
      dialogFormVisible: false,

      formLabelWidth: '150px'
    };
  },
  components: {
    UserinfoDialog
  },
  created () {
    this.getuserInfo()
  },
  beforeRouteEnter: (to, from, next) => {
    let logintoken = !!sessionStorage.getItem('user')
    if (logintoken) {
      next();
    } else {
      next({
        path: '/login'
      })
    }
  },

  methods: {
    closeMoule (e) {
      this.dialogFormVisible = e;
    },
    dialogShow () {
      this.dialogFormVisible = true;
    },
    getuserInfo () {
      User.getUserInfo({ send_email: false }).then(({ data }) => {
        if (data.status === 10000) {
          this.form = data.data
        } else if (data.status === 10001) {
          this.$message.error('用户未登录，请先登录')
        } else {
          this.$message.error(data.message)
        }
      })
    },
    reloaduserinfo (e) {
      if (e) {
        this.getuserInfo()
      }
    }
  }
};
</script>

<style lang='scss' scoped>

.userbox {
  width: 1200px;
  margin: 0 auto;
}
.user-content {
  padding: 40px 60px;
  text-align: left;
}
.el-form-item {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 20px;
  position: relative;
  .warning {
    position: absolute;
    top: 11px;
    left: -94px;
  }
}

.user-title {
  font-size: 18px;
  font-weight: 700;
  padding: 30px 0;
  display: flex;
  align-items: center;
  span {
    margin-left: 10px;
    display: inline-block;
    width: 85%;
    height: 1px;
    background: #ece8e8;
  }
}

.dialog {
  display: inline-block;
  font-weight: 500;
  color: #4473f6;
  border-bottom: 1px solid #4473f6;
  margin-left: 86%;
  font-size: 14px;
  cursor: pointer;
}
</style>
